<script>
import isEqual from "lodash.isequal";

export default {
  name: "SjLinkMenu",
  props: {
    title: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      validator(v) {
        return ["horizontal", "vertical"].includes(v);
      },
      default: "horizontal"
    }
  },
  data() {
    return {
      selected: null,
      panelLabels: [],

      scrollLock: false,
      scrollTimer: null
    };
  },
  render() {
    const { selected, title, mode } = this;
    const { select, handleScroll } = this;

    const panels = (this.$slots.default || []).filter(v => !v.isComment);
    const panelLabels = panels
      .map(v => {
        if (!v.componentOptions) {
          console.warn("LinkMenu should only has LinkMenuItem as slot.");
          return "";
        }
        if (v.componentOptions.Ctor.options.name !== "SjLinkMenuItem") {
          console.warn("LinkMenu should only has LinkMenuItem as slot.");
          return "";
        }
        if (!v.componentOptions.propsData.label) {
          console.warn(
            "LinkMenuItem should provide a label but none is found."
          );
          return "";
        }
        return {
          label: v.componentOptions.propsData.label,
          renderer: v.componentOptions.propsData.labelRenderer
        };
      })
      .filter(v => v);
    this.panelLabels = panelLabels;

    return (
      <div class={["sj-link-menu", mode]}>
        <div class="sj-link-menu-nav">
          <div class="sj-link-menu-nav-wapper">
            {panelLabels.map(v => {
              return (
                <div
                  class={[
                    "sj-link-menu-nav-item",
                    { selected: selected === v.label }
                  ]}
                  onClick={() => select(v.label)}
                >
                  {(v.renderer && v.renderer()) || v.label}
                </div>
              );
            })}
          </div>
          {this.$slots.menuOptions}
        </div>
        <div class="sj-link-menu-main">
          {title || this.$slots.options ? (
            <div class="sj-link-menu-main-title">
              <div class="sj-link-menu-main-title-text">{title}</div>
              {this.$slots.options}
            </div>
          ) : null}
          <div
            class="sj-link-menu-main-content"
            onScroll={e => handleScroll(e)}
          >
            {panels.map(v => {
              return (
                <div
                  class="sj-link-menu-main-content-item"
                  ref={v.componentOptions.propsData.label}
                >
                  <div class="sj-link-menu-main-content-title">
                    {v.componentOptions.propsData.label}
                  </div>
                  {v}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  },
  methods: {
    async select(label) {
      this.scrollLock = true;
      this.selected = label;
      const ref = this.$refs[label];
      let target = ref.offsetTop;
      if (target < 0) target = 0;
      if (
        target >
        ref.parentElement.scrollHeight - ref.parentElement.clientHeight
      ) {
        target =
          ref.parentElement.scrollHeight - ref.parentElement.clientHeight;
      }
      await this.animateScroll(target);
      clearInterval(this.scrollTimer);
      this.scrollLock = false;
    },
    handleScroll(e) {
      if (this.scrollLock) return;
      const top = e ? e.target.scrollTop : 0;
      const contentItems = Array.from(e.target.children);
      if (!contentItems.length) return;
      let indextop = contentItems.findIndex(
        item => item.offsetTop + item.clientHeight >= top
      );
      if (top + e.target.clientHeight === e.target.scrollHeight) {
        indextop = contentItems.length - 1;
      }
      if (indextop === -1) {
        indextop = contentItems.length - 1;
      }
      this.selected = this.panelLabels[indextop].label;
    },
    animateScroll(to, duration = 300) {
      const container = this.$el.querySelector(".sj-link-menu-main-content");
      const from = container.scrollTop;
      const time = Date.now();
      return new Promise(res => {
        clearInterval(this.scrollTimer);
        this.scrollTimer = setInterval(
          () => this.scroll(res, container, from, to, time, time + duration),
          16
        );
      });
    },
    scroll(resolve, target, startPos, endPos, startTime, endTime) {
      const time = Date.now();
      if (time > endTime) {
        resolve();
      } else {
        target.scrollTop =
          startPos +
          (endPos - startPos) *
            (1 - Math.pow((time - startTime) / (endTime - startTime) - 1, 2));
        // target.scrollTop = startPos + (endPos - startPos) * (Math.pow((time - startTime) / (endTime - startTime)-1, 3)+1);
      }
    },
    goTop() {
      this.$el.querySelector(".sj-link-menu-main-content").scrollTop = 0;
    }
  },
  watch: {
    panelLabels: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length && !isEqual(newValue, oldValue)) {
          this.selected = newValue[0].label;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sj-link-menu {
  padding: 10px 0;
  display: flex;
  .sj-link-menu-nav {
    position: relative;
    flex-shrink: 0;
    .sj-link-menu-nav-item {
      cursor: pointer;
    }
  }
  .sj-link-menu-main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    .sj-link-menu-main-title {
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 10px;
      padding: 5px 10px;
      background-color: @linkmenu-main-title-background-color;
      border-radius: @base-border-radius;
      .sj-link-menu-main-title-text {
        .text("h3", "dark", "semibold");
      }
    }
    .sj-link-menu-main-content {
      // OFFICE-3019
      // add 10px to distance from title card
      margin-top: 20px;
      flex: 1;
      min-height: 0;
      overflow: auto;
      position: relative;
      .sj-link-menu-main-content-title {
        .text("body", "dark");
        margin: 20px 0 10px 0;
        padding-left: 10px;
        position: relative;
        &::before {
          position: absolute;
          left: 0;
          top: 7px;
          width: 5px;
          height: 8px;
          background-color: @linkmenu-content-title-marker-color;
          content: "";
        }
      }
      .sj-link-menu-main-content-item:first-of-type {
        .sj-link-menu-main-content-title {
          margin-top: 0;
        }
      }
    }
  }

  &.horizontal {
    position: relative;
    & > .sj-link-menu-nav {
      z-index: 1;
      align-self: flex-start;
      margin: 0 10px;
      width: 130px;
      border-radius: 2px;
      background-color: @linkmenu-nav-background-color;
      box-shadow: 0 4px 8px 0 rgba(144, 164, 183, 0.22);

      & > .sj-link-menu-nav-wapper {
        & > .sj-link-menu-nav-item {
          position: relative;
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding-left: 18px;
          box-sizing: border-box;
          .text("caption", "dark");
          &:hover,
          &.selected {
            background-color: @color-gray-3;
            color: @color-available;
          }
          &:hover::before,
          &.selected::before {
            position: absolute;
            content: "";
            height: 100%;
            width: 2px;
            left: 0px;
            background-color: @color-available;
          }
        }
      }
    }

    & > .sj-link-menu-main {
      position: absolute;
      top: 10px;
      left: 0;
      right: 0;
      bottom: 10px;
      min-width: 0;
      & > .sj-link-menu-main-title {
        box-shadow: 0 4px 8px 0 rgba(144, 164, 183, 0.22);

        margin-left: 150px;
        margin-right: 17px;
      }
      & > .sj-link-menu-main-content {
        padding-left: 150px;
        padding-right: 10px;
      }
    }
  }

  &.vertical {
    flex-direction: column;

    & > .sj-link-menu-nav {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      & > .sj-link-menu-nav-wapper {
        border-bottom: 1px solid @color-gray-3;
        white-space: nowrap;
        flex-shrink: 0;

        & > .sj-link-menu-nav-item {
          position: relative;
          display: inline-block;
          padding: 5px 10px;
          .text("caption", "normal");
          &:hover,
          &.selected {
            color: @color-available;
          }
          &:hover::before,
          &.selected::before {
            position: absolute;
            content: "";
            width: 20px;
            height: 1px;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
            background-color: @color-available;
          }
        }
      }
    }

    & > .sj-link-menu-main {
      min-height: 0;
    }
  }
}
</style>
